import { useMemo } from "react";
import ClientProfessionApi from "./clientProfessionApi";
import useSessionId from "./useSessionId";

function useClientProfessionApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new ClientProfessionApi(sessionId), [sessionId]);
}

export default useClientProfessionApi;
